/* Hand-written React port of src/assets/icons/scoreline.svg — two dashes
   flanking a stacked pair of dots, the abstract shape of `2 - 1`.
   The .svg is the source of truth for the geometry: edit both together.
   It's inlined rather than imported because there's no vite-plugin-svgr in
   this project and one icon doesn't justify adding a build plugin. */

import {
  SCORELINE_NAV_SIZE,
  SCORELINE_VIEWBOX,
  scorelineStrokeWidth,
} from './scorelineGeometry'

interface ScorelineIconProps {
  className?: string
  size?: number
}

/** Structurally prop-compatible with lucide's icons for the way BottomNav and
 * TabPlaceholder use them (`<Icon className=... aria-hidden />`). */
function ScorelineIcon({ className, size = SCORELINE_NAV_SIZE }: ScorelineIconProps) {
  return (
    <svg
      // Stable class so tests and future CSS can target this the way they
      // target lucide's own `lucide-swords` etc. Deliberately *not* `lucide`:
      // that class carries index.css's own width/stroke-width, which would
      // override both the size and the compensated stroke below.
      className={className ? `icon-scoreline ${className}` : 'icon-scoreline'}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${SCORELINE_VIEWBOX} ${SCORELINE_VIEWBOX}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={scorelineStrokeWidth(size)}
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M2.5 12h4.5" />
      <path d="M17 12h4.5" />
      <circle cx="12" cy="8.4" r="1.35" fill="currentColor" stroke="none" />
      <circle cx="12" cy="15.6" r="1.35" fill="currentColor" stroke="none" />
    </svg>
  )
}

export default ScorelineIcon
